// extracted by mini-css-extract-plugin
export default {"container":"CampaignActivityItem_container__KhbiR"};